export enum ECarnivalCircuit {
  CIRCUIT = 'CIRCUIT',
  DISTRICT = 'DISTRICT',
}



export default ECarnivalCircuit;
